// Shared Canada-wide + Manitoba-wide keyword pools appended to service, city,
// combo, and region page SEO metadata. Boosts long-tail Canadian search intent
// without duplicating text in the visible body copy.

export const CANADA_KEYWORDS = [
  "security services Canada",
  "Canadian security guard company",
  "licensed security officers Manitoba",
  "bonded and insured security Manitoba",
  "24/7 security services Canada",
  "professional security guards Canada",
  "commercial security Canada",
  "industrial security Canada",
  "private security company Manitoba",
  "Manitoba Justice private security regulations",
  "security guard licensing Manitoba",
  "unarmed security guards Manitoba",
  "uniformed security officers Manitoba",
  "plainclothes security officers Manitoba",
  "mobile patrol security Canada",
  "static guard services Canada",
  "on-site security guards Manitoba",
  "corporate security firm Canada",
  "risk mitigation security services",
  "loss prevention services Canada",
  "asset protection security Manitoba",
  "GPS-verified patrol reports",
  "audit-ready security documentation",
  "TAPA-influenced logistics security",
  "WHMIS-certified security officers",
  "First aid certified security guards",
  "security services near me Manitoba",
  "hire security guards Manitoba",
  "security company Winnipeg Brandon Thompson",
];

// Return a merged, deduped keyword list.
export function withCanadaKeywords(local = []) {
  return Array.from(new Set([...local, ...CANADA_KEYWORDS]));
}
